import { FlowRoute } from './types'

export const institutionsCoreSkip = (
  { isSecondChanceBankLink, isManualFundingSource },
  { visitedPages }: any,
) => {
  if (isSecondChanceBankLink) {
    return isManualFundingSource ? FlowRoute.RecurringInvestment : FlowRoute.RoundUpsSetup
  }
  if (
    visitedPages.some(
      (path: string) =>
        path === FlowRoute.RoundUpsInterstitial ||
        path === FlowRoute.RecurringInvestment ||
        path === FlowRoute.OneTimeInvestment,
    )
  ) {
    return FlowRoute.Success
  }
  return FlowRoute.PricingInterstitial
}

export const bankLinkSuccessCoreContinue = (
  { roundUpsEnabled, isEligibleRoundUps, isSecondChanceBankLink },
  { visitedPages },
) => {
  if (isSecondChanceBankLink) {
    return isEligibleRoundUps ? FlowRoute.RoundUpsSetup : FlowRoute.RecurringInvestment
  } else if (visitedPages.includes(FlowRoute.RecurringInvestment)) {
    return roundUpsEnabled ? FlowRoute.RoundUpsInterstitial : FlowRoute.RecurringInvestment
  } else if (visitedPages.includes(FlowRoute.OneTimeInvestment)) {
    return roundUpsEnabled ? FlowRoute.RoundUpsInterstitial : FlowRoute.OneTimeInvestment
  }

  return FlowRoute.PricingInterstitial
}

export const portfolioTieredContinue = ({ fundingSource, isEligibleRoundUps }) => {
  if (!fundingSource || isEligibleRoundUps) {
    return FlowRoute.RoundUpsInterstitial
  }

  return FlowRoute.RecurringInvestment
}

export const roundUpsInterstitialContinue = ({ fundingSource }) => {
  if (!fundingSource) {
    return FlowRoute.Institutions
  }

  return FlowRoute.RoundUpsSetup
}

export const addressEdit = () => {
  return FlowRoute.AddressEdit
}
